<template>
  <div class="roles-component">
    <div class="role" v-for="role in getRoles" :key="role">
      <input v-if="!single" type="checkbox" :id="role" :name="role" class="roles" :checked="userRoles.includes(role)" :value="role" @change="checkedRoles" />
      <input v-else type="radio" :id="role" name="role" class="roles" :value="role" @change="checkedRoles" :checked="userRoles.includes(role)" />
      <label :for="role">{{ role }}</label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RolesComponent",
  components: {},
  data() {
    return {};
  },
  props: {
    userRoles: {
      type: Array,
      required: true,
    },
    single: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    ...mapGetters("training", ["getRoles"]),
  },
  methods: {
    checkedRoles() {
      let checked = [];
      if (this.single) {
        const radio = this.$el.querySelector('input.roles[type="radio"]:checked');
        if (radio) {
          checked.push(radio.value);
        }
      } else {
        this.$el.querySelectorAll('input.roles[type="checkbox"]:checked').forEach((checkbox) => {
          checked.push(checkbox.value);
        });
      }
      this.$emit("checked", checked);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.roles-component {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
  .role {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.25rem 1rem;
    border-radius: 2rem;
    border: 1px solid var(--border-colour);
    cursor: pointer;
    transition: border-color 0.15s ease, background-color 0.15s ease;

    &:has(input:checked) {
      border-color: var(--action-colour);
      background-color: var(--opacity-background);
    }

    label {
      text-transform: capitalize;
      color: var(--text-colour);
      margin: 0.25rem 0;
      font-size: 0.85rem;
      cursor: pointer;
      white-space: nowrap;
    }
    input {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;
      pointer-events: none;
    }
  }
}
</style>
